import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';

const ROWS = [
  ['Captación', 'Cada canal corre por su cuenta y el seguimiento se rompe.', 'La oportunidad entra y sigue una ruta operativa más clara.'],
  ['Contratos y cobro', 'Se persiguen documentos y pagos en sistemas separados.', 'Firma, pago y activación pueden quedar encadenados.'],
  ['Operación', 'Cada equipo trabaja con versiones distintas del contexto.', 'Dirección, ventas y operaciones comparten la misma lectura.'],
  ['Integraciones', 'Más conexiones no siempre significan más control.', 'Las integraciones se ordenan alrededor de una lógica común.'],
];

export default function ComparisonPage() {
  return (
    <>
      <SEO title="Comparativa | Neuralia369" description="Comparativa clara entre Neuralia369 y el caos de herramientas sueltas." path="/comparativa" />
      <main className="min-h-screen bg-background px-4 py-16 sm:px-6 lg:px-8" data-testid="comparison-page">
        <div className="mx-auto max-w-7xl space-y-10">
          <motion.section initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} className="max-w-3xl" data-testid="comparison-hero">
            <p className="editorial-kicker mb-4">Comparativa</p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl text-text-heading">Neuralia369 frente al caos de herramientas sueltas.</h1>
            <p className="mt-4 text-lg text-text-body">La diferencia no está en acumular software. Está en tener una capa que ordena cómo trabaja todo junto.</p>
          </motion.section>

          <section className="glass-card tracing-panel overflow-hidden" data-testid="comparison-table-shell">
            <div className="grid md:grid-cols-[0.78fr_1fr_1fr] border-b border-border-subtle">
              <div className="p-5" />
              <div className="p-5 border-t md:border-t-0 md:border-l border-border-subtle bg-background/35" data-testid="comparison-fragmented-column"><p className="text-sm font-semibold text-text-heading">Herramientas sueltas</p></div>
              <div className="p-5 border-t md:border-t-0 md:border-l border-primary/20 bg-primary/10" data-testid="comparison-neuralia-column"><p className="text-sm font-semibold text-text-heading">Neuralia369</p></div>
            </div>
            {ROWS.map(([label, fragmented, neuralia], index) => (
              <div key={label} className="grid md:grid-cols-[0.78fr_1fr_1fr]" data-testid={`comparison-row-${index}`}>
                <div className="p-5 border-b border-border-subtle bg-background/20 text-sm font-semibold text-text-heading">{label}</div>
                <div className="p-5 border-b border-border-subtle md:border-l bg-background/40 text-sm text-text-body">{fragmented}</div>
                <div className="p-5 border-b border-primary/15 md:border-l bg-primary/10/80 text-sm text-text-body">{neuralia}</div>
              </div>
            ))}
          </section>
        </div>
      </main>
    </>
  );
}